import React from 'react'
import cx from 'classnames'
import actions from 'redux/actions'
import { useMedia, useMemo } from 'sb-hooks'
import { constants } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './SelectGender.scss'

// resolve picture x2
import manImage from './images/man.png'
// resolve picture x2
import womanImage from './images/woman.png'
// resolve picture x2
import mobileManImage from './images/man-mobile.png'
// resolve picture x2
import mobileWomanImage from './images/woman-mobile.png'


const GiftPageSelectGender = ({ intl }) => {
  const { isMobile } = useMedia()

  const images = useMemo(() => ({
    male: isMobile ? mobileManImage : manImage,
    female: isMobile ? mobileWomanImage : womanImage,
  }), [ isMobile ])

  return (
    <Box className={s.container} id="selectGender">
      <Text className={s.title} message={messages.title} align="center" size="28-40" semibold />
      {
        [ 'male', 'female' ].map((gender, index) => {
          const sectionClassName  = cx(s.section, s[gender])
          const buttonClassName   = cx(s.button, s[gender])
          const buttonId          = gender === 'male' ? 'buyForHim' : 'buyForHer'
          const buttonTitle       = intl.formatMessage(messages[`${gender}ButtonTitle`])

          return (
            <button
              key={index}
              id={buttonId}
              className={sectionClassName}
              type="button"
              data-testid={constants.testIds.giftSubscription.mainButton}
              aria-label={buttonTitle}
              onClick={() => actions.view.giftPage.startGetGiftFlow(gender)} // This function starts a modals flow. Check giftPage actions
            >
              <Image className={s.picture} fullWidth {...images[gender]} />
              <Box className={s.buttonContainer} alignCenter>
                <Button
                  className={buttonClassName}
                  title={buttonTitle}
                  tag="span"
                  color="brand"
                  size="md"
                  fullWidthOnMobile
                />
              </Box>
            </button>
          )
        })
      }
    </Box>
  )
}


export default injectIntl(GiftPageSelectGender)
